@if (!contentOnly) {

@if (isBackVisible) {
<button mat-icon-button (click)="onBack()" style="color: inherit">
  <mat-icon>{{icon}}</mat-icon>
</button>
}
@else {
<div class="spacer-left"></div>
}

<div class="title">
  <span [ngClass]="getTitleClass()">{{title}}</span>
  @if (subtitle) {
  <span [ngClass]="getSubtitleClass()">{{subtitle}}</span>
  }
</div>

}

<ng-content></ng-content>